export function depth_first_search(grid, startNode, finishNode) {
    const visitedNodesInOrder = [];
    var isTargetFound = depth_first_search_utils(grid, startNode, finishNode, visitedNodesInOrder);
    // depth_first_search_utils(grid, startNode, finishNode, visitedNodesInOrder);
    return visitedNodesInOrder;
}

function depth_first_search_utils(grid, node, finishNode, visitedNodesInOrder) {
    if (node.row === finishNode.row && node.col === finishNode.col) {
        return true;
    }
    node.isVisited = true;
    if (!node.isStart) {
        visitedNodesInOrder.push(node);
    }
    const unvisitedNeighbors = getUnvisitedNeighbors(node, grid);
    for (const i in unvisitedNeighbors) {
        if (unvisitedNeighbors[i].isVisited || unvisitedNeighbors[i].isWall) {
            continue;
        } else {
            // **** current marked visited node will be parent of next visiting node
            unvisitedNeighbors[i].previousNode = node;
            const result = depth_first_search_utils(grid, unvisitedNeighbors[i], finishNode, visitedNodesInOrder);
            if (result === true) {
                return true;
            }
        }
    }
}

function getUnvisitedNeighbors(node, grid) {
    const neighbors = [];
    const { col, row } = node;
    if (row > 0) neighbors.push(grid[row - 1][col]);
    if (row < grid.length - 1) neighbors.push(grid[row + 1][col]);
    if (col > 0) neighbors.push(grid[row][col - 1]);
    if (col < grid[0].length - 1) neighbors.push(grid[row][col + 1]);
    return neighbors.filter(neighbor => !neighbor.isVisited);
}

export function getNodesInShortestPathOrder(finishNode) {
    const nodesInShortestPathOrder = [];
    let currentNode = finishNode;

    while (currentNode !== null) {
        nodesInShortestPathOrder.unshift(currentNode);
        currentNode = currentNode.previousNode;
    }
    return nodesInShortestPathOrder;
}
